import { create } from 'zustand';

type TypeAuthStatus = boolean | 'loading';

type TypeAuthStore = {
  isAuthenticated: TypeAuthStatus;
  setIsAuthenticated: (status: TypeAuthStatus) => void;
};

/**
 * 사용자의 인증 여부 상태를 관리하기 위한 스토어
 */
export const useAuthStore = create<TypeAuthStore>((set) => ({
  isAuthenticated: 'loading',
  setIsAuthenticated: (status) => set({ isAuthenticated: status }),
}));
